module.exports = __webpack_public_path__ + "img/company_summary_banner.a6952efb.webp";